import { Reveal } from "./Reveal";
import { BRANDS } from "../../data/content";

export default function Partners() {
  return (
    <section data-testid="partners-section" className="border-y border-slate-200 bg-white py-14">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <p className="text-center text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">
            Csak minőségi bádogos és tetőfedő alapanyagokat használunk
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-10 gap-y-5 sm:gap-x-14">
            {BRANDS.map((b) => (
              <span
                key={b}
                data-testid={`brand-${b}`}
                className="text-xl sm:text-2xl font-extrabold tracking-tight text-slate-300 transition-colors duration-300 hover:text-[#0E5A75]"
              >
                {b}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
